var map = {
	"./arrow-mobile.svg": 58460,
	"./arrow.svg": 58486,
	"./prize-1.jpeg": 82276,
	"./prize-1.jpg": 7172,
	"./prize-2.jpeg": 85243,
	"./prize-2.jpg": 65248,
	"./prize-3.jpg": 68541,
	"./prize-maldives.png": 86374,
	"./prize-maldives.webp": 58541,
	"./prize-thailand.png": 13888,
	"./prize-thailand.webp": 10118,
	"./prize-uae-2.jpg": 99218,
	"./prize-uae-2.webp": 70648,
	"./prize-uae-3.jpg": 43579,
	"./prize-uae-3.webp": 58508,
	"./prize-uae-4.jpg": 7313,
	"./prize-uae-4.webp": 5522,
	"./prize-uae.png": 57165,
	"./prize-uae.webp": 88029,
	"./super-prize.jpg": 46430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77726;